import { message } from "antd";
import Axios from "axios";
import NProgress from "nprogress";
import { Sessao } from "../helpers/Token";

const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));

const getBaseUrl = () => {
  return icmsModule
    ? process.env.REACT_APP_APICLOUD_URL_ICMS
    : process.env.REACT_APP_APICLOUD_URL;
};

function isDevelopment() {
  return (
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "testing"
  );
}

function ConfiguraAxios(obj) {
  obj.interceptors.request.use(async (config) => {
    try {
      const token = sessionStorage.getItem("eRecuperadorJwt");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      NProgress.start();
    } catch {}

    return config;
  });

  obj.interceptors.response.use(
    async (config) => {
      try {
        NProgress.done();
        return config;
      } catch {}
    },
    (error) => {
      try {
        const status = error && error.response && error.response.status;

        if (status === 401) {
          const planoTeste = Sessao("planoTeste");
          let verificaTeste =
            planoTeste &&
            error.request &&
            error.request.responseURL ===
              "https://apiemultiplicador.e-auditoria.com.br/api/Notificacao";

              // TODO: Ajustar
          // if (!verificaTeste) {
          //   sessionStorage.clear();
          //   window.location = "/";
          // }
        } else if (status === 403) {
          message.error("Usuário sem permissão para realizar a ação");
        }

        NProgress.done();
      } catch {}

      return Promise.reject(error);
    }
  );

  if (isDevelopment()) {
    obj.interceptors.request.use(async (config) => {
      console.log("<= Contagem de requisições");
      return config;
    });
  }

  return obj;
}

export const axios = ConfiguraAxios(
  Axios.create({
    baseURL: getBaseUrl(),
    headers: {
      "Content-Type": "application/json",
    },
    crossdomain: true,
    withCredentials: true,
  })
);

export const axiosPisCofins = ConfiguraAxios(
  Axios.create({
    baseURL: process.env.REACT_APP_APICLOUD_URL,
    headers: {
      "Content-Type": "application/json",
    },
    crossdomain: true,
    withCredentials: true,
  })
);
